module.exports = __webpack_public_path__ + "img/1676339439163-16763394229213149459322436854895.jpg.55d9c074.webp";